var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpset(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 335,
    viewBox: "0 0 123 335",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.669 274.491C122.669 307.666 95.2006 334.552 61.3337 334.552C27.4668 334.552 0 307.654 0 274.491C0 250.895 13.8954 230.476 34.1105 220.654V26.8789C34.081 23.3596 34.7634 19.8693 36.1184 16.6095C37.4733 13.3497 39.4739 10.3849 42.0048 7.88608C44.5358 5.38725 47.5469 3.40387 50.8645 2.05036C54.1821 0.696853 57.7406 0 61.3346 0C64.9286 0 68.4871 0.696853 71.8047 2.05036C75.1224 3.40387 78.1335 5.38725 80.6644 7.88608C83.1953 10.3849 85.196 13.3497 86.5509 16.6095C87.9058 19.8693 88.5882 23.3596 88.5587 26.8789V220.654C108.774 230.474 122.669 250.895 122.669 274.491Z",
    fill: "#CADDDC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M110.87 274.488C110.87 301.285 88.6952 323.004 61.3255 323.004C33.9558 323.004 11.7832 301.285 11.7832 274.488C11.7832 254.404 24.2484 237.169 42.017 229.798V64.9771H80.6378V229.798C98.4008 237.169 110.87 254.404 110.87 274.488Z",
    fill: "#F5B41A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0371 64.9766V27.4367C42.0371 22.4215 44.0716 17.6117 47.693 14.0654C51.3144 10.5191 56.2261 8.52686 61.3475 8.52686C66.469 8.52686 71.3807 10.5191 75.0021 14.0654C78.6235 17.6117 80.6579 22.4215 80.6579 27.4367V64.9766H42.0371Z",
    fill: "#F5B41A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6338 27.437V64.9769H68.923V26.5493C68.923 20.2586 65.4766 10.3724 52.9912 10.3724C55.9352 8.99346 59.1881 8.36768 62.446 8.55347C65.7039 8.73927 68.8606 9.73057 71.6213 11.4348C74.382 13.1391 76.6565 15.5006 78.2326 18.299C79.8086 21.0974 80.6347 24.2412 80.6338 27.437Z",
    fill: "#F5B41A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 30.9507H66.6279V32.8551H76.7052V30.9507Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 47.4819H66.6279V49.3864H76.7052V47.4819Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 35.0239H71.7676V35.9797H76.7174V35.0239Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 38.1382H71.7676V39.094H76.7174V38.1382Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 41.2524H71.7676V42.2082H76.7174V41.2524Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 44.3672H71.7676V45.323H76.7174V44.3672Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 64.0137H66.6279V65.9181H76.7052V64.0137Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 51.5498H71.7676V52.5056H76.7174V51.5498Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 54.6699H71.7676V55.6257H76.7174V54.6699Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 57.7847H71.7676V58.7405H76.7174V57.7847Z",
    fill: "black"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 60.9043H71.7676V61.8601H76.7174V60.9043Z",
    fill: "black"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 80.5503H66.6279V82.4547H76.7052V80.5503Z",
    fill: "black"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 68.0869H71.7676V69.0427H76.7174V68.0869Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 71.1958H71.7676V72.1516H76.7174V71.1958Z",
    fill: "black"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 74.311H71.7676V75.2668H76.7174V74.311Z",
    fill: "black"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 77.4307H71.7676V78.3865H76.7174V77.4307Z",
    fill: "black"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 97.0825H66.6279V98.987H76.7052V97.0825Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 84.6128H71.7676V85.5686H76.7174V84.6128Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 87.7275H71.7676V88.6833H76.7174V87.7275Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 90.8418H71.7676V91.7976H76.7174V90.8418Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 93.9678H71.7676V94.9236H76.7174V93.9678Z",
    fill: "black"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 113.608H66.6279V115.513H76.7052V113.608Z",
    fill: "black"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 101.139H71.7676V102.095H76.7174V101.139Z",
    fill: "black"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 104.259H71.7676V105.215H76.7174V104.259Z",
    fill: "black"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 107.379H71.7676V108.335H76.7174V107.379Z",
    fill: "black"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 110.494H71.7676V111.45H76.7174V110.494Z",
    fill: "black"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 130.14H66.6279V132.045H76.7052V130.14Z",
    fill: "black"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 117.67H71.7676V118.626H76.7174V117.67Z",
    fill: "black"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 120.791H71.7676V121.746H76.7174V120.791Z",
    fill: "black"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 123.911H71.7676V124.866H76.7174V123.911Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 127.025H71.7676V127.981H76.7174V127.025Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 146.671H66.6279V148.576H76.7052V146.671Z",
    fill: "black"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 134.208H71.7676V135.164H76.7174V134.208Z",
    fill: "black"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 137.322H71.7676V138.278H76.7174V137.322Z",
    fill: "black"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 140.443H71.7676V141.399H76.7174V140.443Z",
    fill: "black"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 143.551H71.7676V144.507H76.7174V143.551Z",
    fill: "black"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 163.204H66.6279V165.108H76.7052V163.204Z",
    fill: "black"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 150.739H71.7676V151.695H76.7174V150.739Z",
    fill: "black"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 153.854H71.7676V154.81H76.7174V153.854Z",
    fill: "black"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 156.969H71.7676V157.925H76.7174V156.969Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 160.083H71.7676V161.039H76.7174V160.083Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 179.734H66.6279V181.639H76.7052V179.734Z",
    fill: "black"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 167.271H71.7676V168.227H76.7174V167.271Z",
    fill: "black"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 170.385H71.7676V171.341H76.7174V170.385Z",
    fill: "black"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 173.5H71.7676V174.455H76.7174V173.5Z",
    fill: "black"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 176.62H71.7676V177.576H76.7174V176.62Z",
    fill: "black"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 196.267H66.6279V198.171H76.7052V196.267Z",
    fill: "black"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 183.797H71.7676V184.753H76.7174V183.797Z",
    fill: "black"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 186.912H71.7676V187.867H76.7174V186.912Z",
    fill: "black"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 190.026H71.7676V190.982H76.7174V190.026Z",
    fill: "black"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 193.146H71.7676V194.102H76.7174V193.146Z",
    fill: "black"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7052 212.798H66.6279V214.702H76.7052V212.798Z",
    fill: "black"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 200.329H71.7676V201.284H76.7174V200.329Z",
    fill: "black"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 203.448H71.7676V204.404H76.7174V203.448Z",
    fill: "black"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 206.563H71.7676V207.519H76.7174V206.563Z",
    fill: "black"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7174 209.683H71.7676V210.639H76.7174V209.683Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpset);
export default __webpack_public_path__ + "static/media/upset.eddbd7d61a3c51fb72c9cc13e553c0db.svg";
export { ForwardRef as ReactComponent };